import { render, staticRenderFns } from "./TerminalCommands.vue?vue&type=template&id=6d626eca"
import script from "./TerminalCommands.vue?vue&type=script&lang=js"
export * from "./TerminalCommands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports